/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomComponentTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsSbomComponentTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsSbomComponentTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomComponentTypeQueryOperator>): AppSecopsSbomComponentTypeQueryOperator {
        let obj = Object.assign(new AppSecopsSbomComponentTypeQueryOperator(), model);
        AppSecopsSbomComponentTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomComponentTypeQueryOperator>): AppSecopsSbomComponentTypeQueryOperator {
        if (!model) return null;
        return AppSecopsSbomComponentTypeQueryOperator.newInstance(<AppSecopsSbomComponentTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomComponentTypeQueryOperator) {
        if (!obj) return;

        models.AppSecopsSbomComponentTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomComponentTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomComponentTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * SBOM component type to include
     */
    component_types: Array<models.AppSecopsSbomComponentType>;

}
